module.exports = "data:image/webp;base64,UklGRpYBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSKQAAAABcNvadtsYOccPfIAlW67hwCWcp1ClLVhyBJUeQQNoBfXsVDk9MFgzRITCtG0Y2x23dLvdrHq9aiu73U6wOy+R2OhBfAYlYPUuawAZewCPVVA6PAehEsWKog9AhhxuRMxMAtDTFI6mDEoUnHAD1HQ6eAC3iHKwqwBVgNE6d8CJVgFV4U+nI8R5BdTGANhNpysiZqWEEDEdCAkh2uO2XtPWl01jAVZQOCDMAAAAsAQAnQEqEAAQAAFAJiWcAEyAVZXnoHkZ+fx/d+SPUA/T7/B7wAcPxP5MWCPnQAD+68fw8/w8ryL/y/SZeIbh/vDX/+qI/9onDzG/RXNnqs2SN4rn5s9TAyO7UmzVVp9kb+bO5/7/giAskgSxr/kTqxDpu38uiWKRvRPwx/4ZMoI0vrun5alBXEkZrCdxOkq//ymfYmht+asq77a9Y7554D2rfkVvDG83QEOgPrVfJPCnjHL17ToUcRaVt2Cl0k9xI4mN2tyF1qdoAxgA"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ptgames/ptsearch.webp
// module id = 18E/
// module chunks = 3